import React, { useState } from 'react'
import { Modal, Button, Form, Image } from 'react-bootstrap'

interface FingerprintModalProps {
  show: boolean
  onHide: () => void
  setFingerprintUpdated: (updated: boolean) => void
  onUpload: (fingerprint: string) => void
}

const FingerprintModal: React.FC<FingerprintModalProps> = ({
  show,
  onHide,
  onUpload,
  setFingerprintUpdated,
}) => {
  const [fingerprint, setFingerprint] = useState<string | null>(null)
  const [previewUrl, setPreviewUrl] = useState<string | null>(null)

  const handlePictureChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files ? event.target.files[0] : null

    if (file) {
      const reader = new FileReader()
      reader.onloadend = () => {
        setPreviewUrl(reader.result as string)
        setFingerprint(reader.result as string)
      }
      reader.readAsDataURL(file)
      setFingerprintUpdated(true)
    }
  }

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    if (fingerprint) {
      onUpload(fingerprint)
    }
  }

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Take or Upload a Picture of the Customer Fingerprint</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group controlId="formFile">
            <Form.Label>Choose or take a picture</Form.Label>
            <Form.Control type="file" accept="image*" onChange={handlePictureChange} />
          </Form.Group>

          {previewUrl && (
            <div className="my-3 text-center">
              <div style={{ fontSize: '12px', marginRight: '16px' }}>Existing fingerprint:</div>
              <Image src={previewUrl} alt="Image preview" thumbnail width={300} />
            </div>
          )}

          <Button
            style={{ marginTop: '12px' }}
            variant="primary"
            type="submit"
            disabled={!fingerprint}
          >
            Submit
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default FingerprintModal
